/*!
 * KoliBri - The accessible HTML-Standard
 */
import { r as resolveTargets } from './aria-labelledby-6-ki3akM.js';
import { b as watchValidator, L as Log } from './common-D-vggmh2.js';

const validateAriaDetails = (component, host, internals, value) => {
    watchValidator(component, '_ariaDetails', (value) => typeof value === 'string' || typeof value === 'undefined', new Set(['string']), value);
    const elements = resolveTargets(host, value);
    if (internals) {
        try {
            internals.ariaDetailsElements = elements;
        }
        catch (_a) {
        }
        Log.debug(['WebComponent internals', internals]);
    }
    return elements;
};

export { validateAriaDetails as v };
//# sourceMappingURL=aria-details-hRfn8aN9.js.map

//# sourceMappingURL=aria-details-hRfn8aN9.js.map